// extracted by mini-css-extract-plugin
export var searchHeader = "_9s-0";
export var searchHeaderDark = "_9s-1";